module.exports = __webpack_public_path__ + "media/images/players/NIEMANN_JOAQUIN-a45a01234f872ae3f71f0db2e6a99a53.png";